export default "__VITE_PUBLIC_ASSET__bffb9c49__"